module.exports = __webpack_public_path__ + "static/media/hero.f3389004.jpg";